import React from 'react';
import { t } from 'i18next';

import consent from '../../../../modules/consent';
import Button from '../../Button';


function MapRevokeConsentButton() {
  function handleClick() {
    consent.setConsent({
      dealers: null,
    });
    consent.updateConsent();
  }

  return (
    <Button label={t('Revoke consent')} variation="revoke" onClick={handleClick} />
  );
}

export default MapRevokeConsentButton;
